import {IAuthServiceV2} from "@volkswagen-onehub/authservice";
import {LocaleServiceV1} from "@volkswagen-onehub/locale-service";
import {LoggingFacade} from "@vwdfive/myvw-logging";
import {TrackingManagerV1} from "@volkswagen-onehub/tracking-service";

export interface ITrackingEvent {
    readonly action: TrackingEventAction;
    readonly contentId: string;
    readonly pageName: string;
    readonly sectionName?: string;
    readonly error?: { code: string, message: string }
}

export enum TrackingEventAction {
    VWBasic_Layer_Load,
    VWBasic_Button_Click,
    VWBasic_Screen_Load,
    VWBasic_ErrorMessage_Load,
    VWBasic_Link_Click,
    VWBasic_BackendCall_Result,
    VWBasic_Download_Click,
}

export class TrackingFacade {
    private applicationId = 'VWLocalMyVolkswagenD6';

    constructor(
        private localeService: LocaleServiceV1,
        private trackingService: TrackingManagerV1,
        private loggingFacade: LoggingFacade,
        private authService?: IAuthServiceV2
    ) {
    }

    public async pushEvent(trackingEvent: ITrackingEvent): Promise<void> {
        try {
            const trackingData = await this.createTrackingData(trackingEvent);
            this.trackingService.track(TrackingEventAction[trackingEvent.action], trackingData);
        } catch (e: any) {
            this.loggingFacade.error('TrackingFacade - pushing event failed.', e);
        }
    }

    private async createTrackingData(trackingEvent: ITrackingEvent) {
        const isAuthenticated = this.authService ? await this.authService.isAuthenticated() : false;
        const trackingData: any = {
            eventInfo: {
                contentId: trackingEvent.contentId,
                pageName: trackingEvent.pageName,
                sectionName: trackingEvent.sectionName
            },
            environment: {
                applicationId: this.applicationId,
                language: this.localeService.language,
                country: this.localeService.countryCode
            },
            user: {
                loginStatus: isAuthenticated
            }
        };
        if ([TrackingEventAction.VWBasic_Button_Click, TrackingEventAction.VWBasic_Link_Click,
            TrackingEventAction.VWBasic_Download_Click].includes(trackingEvent.action)) {
            trackingData.link = {name: trackingEvent.contentId, url: this.getPageId()};
        }
        if (trackingEvent.action === TrackingEventAction.VWBasic_ErrorMessage_Load) {
            trackingData.error = {...trackingEvent.error, referringUrl: window.location.href}
        }
        return trackingData;
    }

    // Implementation is taken from: https://github.com/volkswagen-onehub/tracking-service/blob/master/src/v1/index.ts
    private getPageId(): string {
        return `${window.location.host}${window.location.pathname}`;
    }
}
